<template>
  <div class="otherHome">
    <personal :setUp="flag" :page="otherHome"></personal>
  </div>
</template>
<script>
import personal from './personal.vue';
export default {
  name: 'otherHome',
  components: {
    personal
  },
  data() {
    return {
      flag: false,
      otherHome: 'otherHome'
    };
  },
  mounted() {
    if (this.$route.query.id == this.$store.state.memberId) {
      this.flag = true;
    }
  }
};
</script>
<style scoped>
</style>